import { ADJUSTMENT_AUDIT_ACTION, ADJUSTMENT_DRAFT_STATUS } from '@/utils/enum';

const A = ADJUSTMENT_AUDIT_ACTION;
const S = ADJUSTMENT_DRAFT_STATUS;

/** Nhãn tiếng Việt cho `auditLogs[].action` */
export const ADJUSTMENT_AUDIT_ACTION_LABEL_VI = Object.freeze({
  [A.CREATED]: 'Tạo nháp',
  [A.STATUS_CHANGED]: 'Đổi trạng thái',
  [A.ISSUED]: 'Phát hành thành công',
  [A.RETRIED]: 'Thử lại phát hành',
  [A.DELETED]: 'Đã xóa nháp',
  [A.FAST_SYNC_TRIGGERED]: 'Kích hoạt đồng bộ FAST',
  [A.FAST_SYNC_SUCCESS]: 'Đồng bộ FAST thành công',
  [A.FAST_SYNC_FAILED]: 'Đồng bộ FAST thất bại',
  [A.BUYER_TAX_CODE_EDITED]: 'Sửa MST người mua',
});

/** Nhãn tiếng Việt cho `oldStatus` / `newStatus` — khớp AdjustmentStatusBadge */
export const ADJUSTMENT_DRAFT_STATUS_LABEL_VI = Object.freeze({
  [S.DRAFT]: 'Nháp',
  [S.READY_TO_ISSUE]: 'Sẵn sàng phát hành',
  [S.ISSUING]: 'Đang phát hành',
  [S.ISSUED]: 'Đã phát hành',
  [S.WAITING_PROVIDER]: 'Chờ CQT',
  [S.ISSUE_FAILED]: 'Lỗi phát hành',
  [S.RETRYING]: 'Đang thử lại',
  [S.FAST_SYNCING]: 'Đang đồng bộ',
  [S.FAST_SYNCED]: 'Đã đồng bộ',
  [S.FAST_SYNC_FAILED]: 'Lỗi đồng bộ',
  [S.DELETED]: 'Đã xóa',
  [S.CANCELLED]: 'Đã hủy',
});

export function getAdjustmentAuditActionLabelVi(action) {
  if (action == null || action === '') return '—';
  return ADJUSTMENT_AUDIT_ACTION_LABEL_VI[action] || String(action);
}

export function getAdjustmentDraftStatusLabelVi(status) {
  if (status == null || status === '') return '—';
  return ADJUSTMENT_DRAFT_STATUS_LABEL_VI[status] || String(status);
}
